const ORIGIN_FIELDS = [
  'triggeringMentions',
  'triggeringConsequences',
  'triggeringDemerits',
  'triggeredBy',
  'mentionId',
  'triggerMentionId',
  'sourceMentionId',
  'originMentionId',
];

function values(value) {
  return (Array.isArray(value) ? value : [value])
    .map(item => typeof item === 'string' ? item.trim() : '')
    .filter(Boolean);
}

export function consequenceOriginIds(consequence = {}) {
  return [...new Set(
    ORIGIN_FIELDS.flatMap(field => values(consequence[field])),
  )].sort();
}

function hash32(input, seed) {
  let hash = seed >>> 0;
  for (let index = 0; index < input.length; index += 1) {
    hash ^= input.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash.toString(16).padStart(8, '0');
}

export function deterministicAutoConsequenceId(consequence = {}) {
  if (consequence.autoGenerated !== true) return null;
  const originIds = consequenceOriginIds(consequence);
  if (originIds.length === 0) return null;
  const identity = [
    consequence.schoolId || '',
    consequence.studentId || '',
    consequence.triggeredByRule || consequence.ruleId || '',
    consequence.ruleType || '',
    consequence.type || consequence.consequenceType || '',
    originIds.join(','),
    consequence.isReschedule === true
      ? `reschedule:${consequence.rescheduledFrom || ''}:${consequence.attemptNumber || ''}`
      : 'origin',
  ].join('|');
  return `auto_${hash32(identity, 0x811c9dc5)}${hash32(identity, 0x9e3779b9)}`;
}

export function deterministicManualConsequenceId(consequence = {}) {
  const requestId = typeof consequence.manualCreationRequestId === 'string'
    ? consequence.manualCreationRequestId.trim()
    : '';
  if (consequence.autoGenerated === true || !requestId) return null;
  const identity = [
    consequence.schoolId || '',
    consequence.studentId || '',
    requestId,
  ].join('|');
  return `manual_${hash32(identity, 0x811c9dc5)}${hash32(identity, 0x9e3779b9)}`;
}

export function requireAutoConsequenceOrigin(consequence = {}) {
  if (
    consequence.autoGenerated === true &&
    consequenceOriginIds(consequence).length === 0
  ) {
    throw new Error(
      'Auto-generated Queue consequence requires a Mention or consequence origin',
    );
  }
}
